import { toKebabCase, removeAccents } from '@lno/utils/string'

export const sanitizeText = (str: string) => toKebabCase(removeAccents(str))
